import React from 'react';
import './shrineInformationPartStyle.scss';
import './shrineInformationPartStyle.scss';
import photo2 from '../../../assets/haramImage/haram5.jpg'
import photo4 from '../../../assets/haramImage/photo4.jpg'
 function Katibe() {
  return (
      <div className='information-section'>
    <h3>کتیبه های بقعه امامزاده جعفر </h3>
     <p>     
در بناهای اسلامی معمولا از کتیبه با کاربرد چند جانبه استفاده میشود . کتیبه هایی که در بناهای مذهبی به کار می روند جنبه های اعتقادی ، انتقال اطلاعات و از همه بیشتر ارزش های تزئینی دارند . به همین جهت در اکثر بناهای اسلامی از کتیبه به شکل های گوناکون استفاده شده است . در بقعه امامزاده جعفر نیز از کتیبه با هر سه کاربرد استفاده شده است .  
    </p>
    <br />
    <img className='col-11 col-md-6' src={photo2} alt="امام زاده جعفر" />
    <br />
    <h5>کتیبه های بقعه امامزاده جعفر در حال حاضر در پنج نقطه از بنا مشاهده می شوند : </h5>
<li className='alingSelf-start'>کتیبه ی ایوان شرقی </li>
<li className='alingSelf-start'>کتیبه در ورودی حرم </li>
<li className='alingSelf-start'>کتیبه  در ضریح </li>
<li className='alingSelf-start'>کتیبه های گنبد </li>
<br />

<h5>کتیبه های ایوان </h5>
    <p className='alingSelf-start'>
    این کتیبه دارای ۲۵ بیت از اشعار فتحعلی خان صبا می باشد که بر روی ۵۰ لوح و روی ۴۵۰ قطعه کاشی به خط نستعلیق سفید بر زمینه لاجوردی نوشته شده:
    </p>
<div className='shear-box'> 
  <div className='shear-section pb-2'>
  <span>مالک رقاب عالم دارای دادگستر</span>
  <span>شمس الملوک اعظم خاقان پاک گوهر </span>
  </div>

  <div className='shear-section'>
  <span >گردی ز قصر جاهش ، گردون سایه افکن </span>
  <span>دودی ز شمع رویش خورشید نور گستر </span>
  </div>

</div>
<br />

<h5>کتیبه گنبد </h5>
<p className='alingSelf-start'>به خط ثلث است و از گوشه پایین لنگه سمت راست شروع می شود و به پایین ضلع چپ ختم می شود . متن کتیبع صلوات بر حضرت رسول اکرم ( ص ) و دوازده امام می باشد .</p>
<br />

<img className='col-11 col-md-6' src={photo4} alt="امام زاده جعفر" />
<br />
      <h5>کتیبه در ضریح</h5>     
      <p>به خط نستعلیق است . درون چهار قاب با حواشی گل و‌گیاه است که بر روی هر لت آن یکی در بالا و یکی در میان در پایین به خط استاد محمد بن علاالدین رازی نوشته شده  ، متن کتیبه چنین است:</p>     
       
       <div className='ghab-style'>
        <h6>قاب اول:</h6>
        <span> وقف کرد به آستانه متبرکه واجب التعظیم امامزاده جعفر جواری .</span>
        </div>  
        <div className='ghab-style'>
        <h6>قاب دوم:</h6>
        <span>ابن الامام الهمام امام موسی الکاظم علیه تحیه و السلام سنه ۹۹۴ . </span>
        </div> 
        <div className='ghab-style'>
        <h6>قاب سوم:</h6>
        <span>نواب نامدار معدلت شعار کردون وقار مختار شرف الدین اوغلی</span>
        </div> 
        <div className='ghab-style'>
        <h6>قاب چهارم:</h6>
        <span> عمل استاد بن استاد محمد علاالدین رازی تمه فی عزّه جمادی الاخر سنه اربع و تسعین و تسع مائه .</span>
        </div>  
           <br />
            </div>
  )
}
export default Katibe;